<template>
    <div class="v--modal-box v--modal vue-dialog">
        <div class="dialog-content">
            <div class="dialog-c-title">Запуск переделки заказа № {{order.SferaNumber}} / {{order.RecastNumber}}</div>
            <div class="dialog-c-text">
                <div class="alert alert-info">
                        Цена всех переделок суммируется для клиента
                </div>
                <div class="form-group">
                    <input v-model="price" type="number" class="form-control" placeholder="Цена за переделку" required/>
                </div>
            </div>
        </div>
        <div class="vue-dialog-buttons">
            <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click.prevent="submit">ОК</button>
            <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="$emit('close')">Отмена</button>
        </div>
        <v-dialog @closed="$emit('close')"/>
    </div>
</template>
<script>
import { get, post } from '@/admin/services/api/http-utils';

const url = process.env.VUE_APP_API_HOST;
export default {
  name: 'RecastRequest',
  props: {
    orderItemId: Number,
  },
  data() {
    return {
      order: {},
      price: null,
    };
  },
  async mounted() {
    await this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      const { data } = await get(`${url}admin/order/${this.orderItemId}`);
      this.order = data;
    },
    async submit() {
      await post(`${url}admin/recast`, { orderItemId: this.orderItemId, price: this.price });
      this.$modal.show('dialog', {
        title: 'Заказ отправлен в переделку!',
      }, {
        pivotY: 0.2,
      });
      // this.$emit('close');
    },
  },
};
</script>
